import React, { useEffect, useState, useRef } from 'react';
import {
  useNavigate,
  useLocation
} from "react-router-dom";
import Select from 'react-select'
import LoginService from "../services/login.service";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
// import { ConfirmPopup } from '../components/ConfirmPopup';

import axios from 'axios';
let Config;
let domain = window.location.hostname;
if ( domain.includes('localhost') || domain.includes('s4ldev') || domain.includes('s4luat') ) 
  Config = require('./Config_UAT.json');
else
  Config = require('./Config_PROD.json');

const EditorHome = () => {
    const [showModal, setShowModal] = useState(false);
    const handleClose = () => {
      setShowModal(false);
      //navigate("/s4l/");
      //setSelectedOption('Select a role');
    }
    const [confirmMessage, setConfirmMessage] = useState('Warning: This system boundary has already been certified and reviewed. If you proceed, it will need to be re-certified and re-reviewed. Proceed?');
    const [selectedOption, setSelectedOption] = useState(null);
    const [message, setMessage] = useState(''); 
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const selectRef = useRef(null);
    const [selectedUserRole, setSelectedUserRole] = useState(null); 
    const [userData, setUserData] = useState(null);

 /*    useEffect(() => {
      if (show) {   
        console.log('Perform actions when the modal opens');
        console.log(show);
      }
    }, [show]); */
    
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    const getUserData = (wdid) => {
      let serverUrl = Config.server.serverUrl;
      let portalUrl = Config.server.portalUrl;
      const formData = new FormData();
      formData.append(
        "f", "json"
      );
      formData.append(
        "token", Config.server.apiKey
      );
      formData.set(
        "where", "CS_WDID = '{CS_WDID}'".replace('{CS_WDID}', wdid)
      );
      formData.set(
        "outFields", "*"
      );
      //let getCsMap = `${serverUrl}/S4L_CS_Boundaries/MapServer/1/query`;
      let getCsMap = `${portalUrl}/sharing/servers/${Config.server.layerPortalItem}/rest/services/S4L/S4L_CS_Boundaries/FeatureServer/1/query`
      axios.post(`${getCsMap}`, formData).then(function (response) {
        console.log('response = ', response);
        if ( response.data.features.length === 0 ) {
           const csInfo = {
              "UPLOAD_DATE": null,
              "CERTIFIED_YN": null,
              "REVIEW_STATUS": null
            };
           setUserData(csInfo);
        } 
        else {
           setUserData(response.data.features[0].attributes);
        }
      })
        .catch(function (error) {
          console.log(error);
      }); 
    } 
    userInfo.sort((a, b) => {
      return a.wdid.localeCompare(b.wdid);
    });
    console.log(userInfo);  
    const userOptionsAPI = userInfo.map((user) => ({
      value: user.userRole +  ' - ' + user.wdid +  ' - ' + user.collectionSpillName , 
      label: user.userRole +  ' - ' + user.wdid +  ' - ' + user.collectionSpillName 
    }));
    const userOptionsNoReview = userInfo.filter(function (entry) {
      return entry.UserRole !== 'Reviewer';
    });
    const userOptionsFull = userOptionsNoReview.map((user) => ({
      value: user.userRole +  ' - ' + user.wdid +  ' - ' + user.collectionSpillName , 
      label: user.userRole +  ' - ' + user.wdid +  ' - ' + user.collectionSpillName 
    }));
    let userOptions = userOptionsNoReview.map((user) => ({
      value: user.wdid +  ' - ' + user.collectionSpillName , 
      label: /* user.userRole + ' - ' + */ user.wdid +  ' - ' + user.collectionSpillName 
    }));
    
    const s4lUser = JSON.parse(localStorage.getItem('s4l'));
    let navigate = useNavigate();

    function getPosition(string, subString, index) {
      return string.split(subString, index).join(subString).length;
    }
 
    function getWdid (item) {
      if  ( item != null ) {
        if (item.value.substr(9, 2) == '-C')  
          return item.value.substr(0, 11);  
        else   
          return item.value.substr(0, 9);
      }
      else {
        return '';
      }
    }

    function getCsName (item) {
      if  ( item != null ) {
        let index =  getPosition(item.value, '-', 1); 
        if (item.value.substr(9, 2) == '-C') 
           index =  getPosition(item.value, '-', 2);
        return item.value.substr(index + 2);
      }
      else {
        return '';
      }
    }

/*     const handleChange = (event) => {
      setSelectedOption(event.target.value);
    }; */

    const handleChange = (selectedOption) => {
      setSelectedOption(selectedOption);
      const wdid = getWdid(selectedOption);
      getUserData(wdid);
      localStorage.setItem('s4l_wdid', wdid);
      const csName = getCsName(selectedOption);
      localStorage.setItem('s4l_csname', csName);
      let userRoleSelected = userOptionsFull.find((user) => {return user.label.indexOf(wdid) > 0});
      let roleEnd = userRoleSelected.label.indexOf("-") - 1;
      setSelectedUserRole(userRoleSelected.label.substr(0, roleEnd));
    };
  
    const handleClick = (action) => {
      if ( selectedOption === null ) {
        setMessage("Please select a Collection System to submit.");
      }
      else {
        localStorage.setItem("userRole", selectedUserRole);
        if (action === "Upload") {            
          //LoginService.findByWdid(getWdid(selectedOption)).then(response => {
            console.log(userData);
            var epoch = new Date(userData.UPLOAD_DATE);
            let inputStr = (epoch.getMonth() + 1) + "/" + (epoch.getDate() + 1) + "/" + epoch.getFullYear();
            console.log("uploadDate = " +  inputStr);
            if ( (userData.UPLOAD_DATE !== null) && (userData.UPLOAD_DATE !== 0) )  {
              if ( userData.CERTIFIED_YN === 'Y' )  {
                if ( userData.REVIEW_STATUS === 0 )  {
                  setConfirmMessage('Warning: This system boundary has already been certified. If you proceed, it will need to be re-certified. Proceed?');                 
                }
                setShowModal(true);
              } 
              else {
                localStorage.setItem("action", "Replace");
                navigate("/s4l/map");
              }                      
            }
            else {
              localStorage.setItem("action", "Upload");
              navigate("/s4l/map");
            }               
          //}) 
        }
        else {
          localStorage.setItem("action", "Certify");
          navigate("/s4l/map");
        }
      }
    };

    useEffect(() => {
      /* if (userInfo.length == 1) {
        localStorage.setItem('s4l_wdid', getWdid(userInfo[0]));
        navigate("/s4l/map");
      } */  
        if (menuIsOpen) {
          selectRef.current.focus();
        }
    },[])
  
    return (
      <div className="col-8 offset-2 mt-5 text-center">
        <div className="form-group">
          <h3 className="text-black" > Hello, {s4lUser.username}  </h3>
          <h3 className="text-black" > 
             { (userOptions.length == 1 && userOptions[0].value == '404 - null') ? 'No sewer systems are associated with your CIWQS account.' : 'Select a sewer system to continue'  } 
          </h3>
          <br/>

          {  
           !(userOptions.length == 1 && userOptions[0].value == '404 - null') ? 
            <Select 
              className="col-4 offset-4 text-left" 
              ref={selectRef}
              value={selectedOption} 
              onChange={handleChange} 
              options={userOptions} 
              placeholder='Select a sewer system'
              menuIsOpen={menuIsOpen} 
              onMenuOpen={() => setMenuIsOpen(true)}
              onMenuClose={() => setMenuIsOpen(false)}    
            /> 
            :
            ''                
          }
          <br/>

          {  selectedUserRole && <button className="btn btn-primary m-2" onClick={() => handleClick("Upload")} >Upload</button>  }
          {  selectedUserRole && ( selectedUserRole === "Certifier" ) && (userData?.UPLOAD_DATE !== null) && (userData?.UPLOAD_DATE !== 0) && <button className="btn btn-primary m-2" onClick={() => handleClick("Certify")} >Certify</button> }
          {  selectedUserRole && ( selectedUserRole === "Uploader" || ( (userData?.UPLOAD_DATE === null) || (userData?.UPLOAD_DATE === 0) ) ) && <button className="btn btn-primary m-2" style={{ backgroundColor: 'grey', borderColor: 'grey' }} disabled onClick={() => handleClick("Certify")} >Certify</button> }
                   
                 
          {message && <p className="text-danger">{message}</p>}
          <h3 className="text-black" > 
            If you don't see the sewer system you expect, see the <a href="https://www.waterboards.ca.gov/water_issues/programs/sso/docs/2025/s4l-guide.pdf" target="_blank" > S4L user guidance document </a>
          </h3>

        </div>

        <Modal show={showModal} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Please Confirm</Modal.Title>
          </Modal.Header>
          <Modal.Body> { confirmMessage } </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              No
            </Button>
            <Button variant="primary" onClick={() => {localStorage.setItem("action", "Replace"); navigate("/s4l/map")}}>
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
  
      </div>
    );
  };
  
  export default EditorHome;